module.exports = __webpack_public_path__ + "media/images/quote-1caebc312601d3aa95957faa9b6479e9.svg";